import { gql } from '@apollo/client';
import { PaymentType, StatusType } from '../../modules/bookings';

export interface CustomerPaymentMethod {
  paymentMethod: {
    type: PaymentType;
    status: StatusType;
  };
}

export const CUSTOMER_PAYMENT_METHOD = gql`
  query paymentMethod($quoteId: String!) {
    paymentMethod(quoteId: $quoteId) {
      type
      status
    }
  }
`;
